
  Vue.component('editor', Editor)
  Vue.component('memo-sticky-note', {
    props: {
      fixedStyle: { type: Object },
      saveMemo: { type: Function },
      closeMemo: { type: Function },
      selectMemo: { type: Function },
      newMemo: { type: Function },
      deleteMemo: { type: Function },
      memos: { type: Array },
      show: { type: Boolean, default: false },
      text: { type: String },
      title: { type: String },
      colorStyle: { type: String, default: 'Giallo' },
      id: { type: Number, default: -1 },
      idx: { type: Number, required: true },
      curriculumId: { type: Number, required: true },
      selected: { type: Boolean, default: false }
    },
    data() {
      return {
        value: this.text,
        titleValue: this.title,
        selectedStyle: this.colorStyle || 'Giallo',
        showColorPicker: false,
        editTitle: false
      }
    },
    template: '#memo-sticky-note',
    computed: {
      ...Pinia.mapState(useCurriculumMemosStore, {
        saving: store => store.saving
      }),
      showBookmark() {
        return this.memos.length > 1
      },
      isAlone() {
        return this.memos.length == 1
      },
      memosCount() {
        return this.memos.length
      },
      isNew() {
        return this.id === -1
      },
      modified() {
        return (
          this.text !== this.value ||
          (this.selectedStyle !== this.colorStyle && this.value != '') ||
          (this.title !== this.titleValue && this.value != '')
        )
      },
      colorStyles() {
        return [
          { name: 'Giallo', color: '#ffffff' },
          { name: 'Verde', color: '#ffffff' },
          { name: 'Rosa', color: '#ffffff' },
          { name: 'Viola', color: '#ffffff' },
          { name: 'Blu', color: '#ffffff' },
          { name: 'Grigio', color: '#ffffff' },
          { name: 'Carbone', color: '#ffffff' }
        ]
      }
    },
    watch: {},
    methods: {
      enterTitleEditMode() {
        this.editTitle = true
        setTimeout(() => this.$refs.inputTitle.focus(), 200)
      },
      save() {
        if (this.modified) {
          this.saveMemo(this.id, this.curriculumId, this.value, this.selectedStyle, this.titleValue)
        }
      },
      saveAndClose(forceClose = false) {
        let close = forceClose
        if (this.modified) {
          this.saveMemo(this.id, this.curriculumId, this.value, this.selectedStyle, this.titleValue)
          if (this.isAlone && this.value === '') {
            close = true
          }
        } else {
          close = true
        }
        if (close) this.closeMemo()
      },
      deleteAndCloseMemo(id, curriculumId) {
        this.deleteMemo(id, curriculumId)
        if (this.isAlone) {
          this.closeMemo()
        }
      },
      toggleColorPicker() {
        this.showColorPicker = !this.showColorPicker
      },
      selectColor(color) {
        this.selectedStyle = color
        this.showColorPicker = false
      },
      bookmarkHeight() {
        let memoHeight = 260 / this.memosCount
        memoHeight = memoHeight > 39 ? 39 : memoHeight
        return Math.round(memoHeight)
      },
      bookmarkMarginTop(id) {
        let memoHeight = 260 / this.memosCount
        memoHeight = memoHeight > 39 ? 39 : memoHeight
        return Math.round(34 + memoHeight * id)
      }
    },
    mounted() {},
    beforeDestroy() {}
  })
